import type { FunctionComponent } from "react";

import { BaseLink } from "~/components/common/base-link";
import { useEditionValue } from "~/lib/edition";
import { useGetHomeAsPath } from "~/lib/router/hooks";
import { page as HomePage } from "~/pages/home";
import { page as PostiesPage } from "~/pages/posties";

import {
  Container,
  Content,
  Copyright,
  Header,
  LogoCopyrightContainer,
  LogoPosties,
  StyledLogoScmp,
  StyledPostiesEnquires,
  StyledPostiesSitemap,
  StyledPostiesSocialMedia,
  Wrapper,
} from "./styles";

export const PostiesFooter: FunctionComponent = () => {
  const edition = useEditionValue();
  const homeAsPath = useGetHomeAsPath();

  const { pathname: postiesPagePathname, query: postiesPageQuery } = PostiesPage.route({});
  const { pathname: homePagePathname, query: homePageQuery } = HomePage.route({
    edition,
    slide: "main",
  });

  return (
    <Container>
      <Wrapper>
        <Header>
          <BaseLink as="/posties" pathname={postiesPagePathname} query={{ ...postiesPageQuery }}>
            <LogoPosties />
          </BaseLink>
          <StyledPostiesSocialMedia />
        </Header>
        <Content>
          <StyledPostiesSitemap />
          <StyledPostiesEnquires />
        </Content>
        <LogoCopyrightContainer>
          <BaseLink as={homeAsPath} pathname={homePagePathname} query={{ ...homePageQuery }}>
            <StyledLogoScmp />
          </BaseLink>
          <Copyright>
            Copyright © {new Date().getFullYear()} South China Morning Post Publishers Ltd. All
            rights reserved.
          </Copyright>
        </LogoCopyrightContainer>
      </Wrapper>
    </Container>
  );
};

PostiesFooter.displayName = "PostiesFooter";
